"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoyaltiesRoutes = void 0;
const route_1 = require("@App/navigation/route");
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const permissions_1 = require("@Const/permissions");
const navigation_1 = __importDefault(require("@App/navigation"));
const RightsholderRoyaltiesStatements_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesStatements"));
const RightsholderRoyaltiesAnnualStatements_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesAnnualStatements"));
const RightsholderRoyaltiesRateSheets_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyaltiesRateSheets"));
const RightsholderRoyalties_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderRoyalties"));
const react_1 = __importDefault(require("react"));
const createRoyaltiesRoutes = () => [
    {
        path: route_1.RIGHTSHOLDER_SUB_ROUTES.royalties.statements,
        element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
            ], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
            react_1.default.createElement(RightsholderRoyaltiesStatements_1.default, null))),
    },
    {
        path: route_1.RIGHTSHOLDER_SUB_ROUTES.royalties.annualStatements,
        element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
            ], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
            react_1.default.createElement(RightsholderRoyaltiesAnnualStatements_1.default, null))),
    },
    {
        path: route_1.RIGHTSHOLDER_SUB_ROUTES.royalties.rateSheets,
        element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
            ], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
            react_1.default.createElement(RightsholderRoyaltiesRateSheets_1.default, null))),
    },
    {
        path: route_1.RIGHTSHOLDER_SUB_ROUTES.royalties.root,
        element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_contact_and_address,
                permissions_1.PERMISSIONS.RIGHTSHOLDER_PERMISSIONS.manage_banking_and_tax,
            ], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
            react_1.default.createElement(RightsholderRoyalties_1.default, null))),
    },
];
exports.createRoyaltiesRoutes = createRoyaltiesRoutes;
